<template>
    <UserPageLayout></UserPageLayout>
</template>

<script>
import UserPageLayout from '@/layouts/UserPage'
import UserService from '@/lib/user'
import { currentUser } from '@/lib/user'
import appConfig from '@/app.config.js'
import Request from '@/lib/request.js'
import popup from '@/lib/popup.js'

export default {
    components: {
        UserPageLayout
    },

    mounted() {
        const userService = new UserService()

        if (!userService.isLoggedIn()) {
            this.$store.commit('setShowFeideLogin', true)
        } else {
            if (this.isStudent) {
                window.location.replace('/skoler')
            } else {
                this.loginRedirectTo()
            }
        }

        window.addEventListener('feide-login-success', () => {
            this.loginRedirectTo()
        })
    },

    computed: {
        isStudent() {
            return currentUser().role.includes('student')
        }
    },

    methods: {
        setShareQuizToUser() {
            return new Promise((resolve, reject) => {
                const userService = new UserService()
                const request = new Request()
                const quizId = this.$route.query.id
                const token = this.$route.query.token
                const url = appConfig.api.setUserShareQuiz.replace('__id__', quizId).replace('__token__', token)

                let formData = {
                    userId: userService.getUser().id,
                    userEmail: userService.getUser().email
                }

                request.post(url, formData).then(resolve).catch(reject)
            })
        },

        async loginRedirectTo() {
            this.$store.commit('toggleMainLoader', true)

            if (this.$route.query.share && this.$route.query.id && this.$route.query.token) {
                try {
                    await this.setShareQuizToUser()
                    return this.$router.replace({
                        name: 'my-quiz',
                        query: {
                            type: 'share',
                            share: true
                        }
                    })
                } catch (err) {
                    if (err.response.status) {
                        return popup.alert(err.response.data.message, () => {
                            window.location.href = this.$router.resolve({
                                name: 'my-quiz'
                            }).href
                        })
                    }
                    return
                }
            }

            if (this.$route.query.path) {
                window.location.replace(atob(this.$route.query.path))
            } else {
                window.location.replace('/skoler')
            }
        }
    }
}
</script>

<style lang="scss">
#feide-login-modal {
    .backdrop {
        background-color: rgba(0, 0, 0, 0.2) !important;
    }
}
</style>
